import { Controller } from '@hotwired/stimulus';
import { Carousel } from 'bootstrap';
import { isVisited } from '../../utils/ad_visit_db_manager';
import { captureException } from '@sentry/browser';
export default class CardManualController extends Controller {
  static values = { adId: String };
  static targets = ['visitedLabel', 'carousel'];

  connect() {
    void this.checkVisited();
    this.initializeCarousel();
  }

  disconnect() {
    if (this.carousel) {
      this.carousel.dispose();
      this.carousel = null;
    }
  }

  async checkVisited() {
    if (!this.hasAdIdValue || !this.adIdValue) {
      return;
    }

    try {
      const visited = await isVisited(this.adIdValue);
      if (visited && this.hasVisitedLabelTarget) {
        this.visitedLabelTarget.classList.remove('d-none');
      }
    } catch (error) {
      captureException(error);
    }
  }

  initializeCarousel() {
    if (this.hasCarouselTarget) {
      this.carousel = Carousel.getOrCreateInstance(this.carouselTarget, { ride: false });
    }
  }
}
